import logoSuccess from 'assets/icons/Check.svg'
import LogoPasmik from 'assets/icons/PasarMIKRO-Primary-Logogram-3.svg'
import CustomButton from 'components/Buttons/CustomButton'
import { ArrowLeft } from 'react-feather'
import { useLocation, useNavigate } from 'react-router-dom'

const Success = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const dataState = location.state

  return (
    <div className="flex-centered flex-column" style={{ minHeight: '100vh' }}>
      <div className="flex-centered py-3">
        {' '}
        <img
          style={{ width: '100%', maxWidth: '80px', height: 'auto' }}
          src={LogoPasmik}
          alt="PasarMIKRO logo"
        />{' '}
      </div>
      <div className="flex-centered py-3">
        {' '}
        <img
          style={{ width: '100%', maxWidth: '120px', height: 'auto' }}
          src={logoSuccess}
          alt="PasarMIKRO logo"
        />{' '}
      </div>
      <h3 className="fw-600 text-center py-3" data-testid="payment-success-title">
        Pembayaran Anda telah diterima
      </h3>
      <span className="pb-3">Silakan lanjutkan aktivitas Anda</span>

      {dataState?.purpose === 'TOPUP' ? (
        <CustomButton
          testId="payment-success-back-button"
          onClick={() => {
            navigate(-1, { replace: true })
          }}
          outline
          color="primary"
        >
          <ArrowLeft size={20} /> Kembali
        </CustomButton>
      ) : (
        <></>
      )}
    </div>
  )
}

export default Success
